import MediaEvent from 'umg-ember-backend/components/record-explorer/for/media-event';

<template>
  <MediaEvent @records={{@model}} @recordType='media-event' />
</template>
